import FeaturesContainer from './FeaturesContainer'

const CheckIn = ({ history }) => {
    return <FeaturesContainer history={history} pageName={'check-in'} nextUrl={'location-history'} pageEvent={'onboardingCheckIn'} clickEvent={'onboardingCheckInSubmitted'} />
};

export default CheckIn
